import { dropStatusDocumento, dropOperacao } from 'utils/drops';

const getEstoqueFilterFields = (drops = {}) => [
  { name: 'id', label: 'ID', type: 'number', defaultValue: '' },
  {
    name: 'status',
    label: 'Status',
    type: 'select',
    options: dropStatusDocumento,
    multiple: true,
    defaultValue: ['PENDENTE'],
    initial: true,
  },
  {
    name: 'situacao',
    label: 'Situação',
    type: 'select',
    options: drops?.StatusDocumento,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'dtemissao.i',
    column: 'dtemissao',
    label: 'Data de Emissão Inicial',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'dtemissao.f',
    column: 'dtemissao',
    label: 'Data de Emissão Final',
    type: 'date',
    defaultValue: null,
  },
  {
    name: 'operacao',
    label: 'Operação',
    type: 'select',
    options: dropOperacao,
    multiple: true,
    defaultValue: [],
  },
  {
    name: 'requisitante',
    label: 'Requisitante',
    type: 'select',
    options: drops?.Users,
    multiple: true,
    defaultValue: [],
  },
  { name: 'origem', label: 'Origem', defaultValue: '' },
];

export default getEstoqueFilterFields;
